import initSelect from './initSelect';

export default initSelect;



// WEBPACK FOOTER //
// ./scripts/lib/select/index.js